import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";

export class ReservationType1SolicitorModel extends ModelBase<ReservationType1SolicitorModel, ReservationType1SolicitorDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public reservationId: string = "";

    @observable
    public purchaserSolicitorName: string | null = "";

    @observable
    public purchaserSolicitorPersonName: string | null = "";

    @observable
    public purchaserSolicitorAddress1: string | null = "";

    @observable
    public purchaserSolicitorAddress2: string | null = "";

    @observable
    public purchaserSolicitorCity: string | null = "";

    @observable
    public purchaserSolicitorPostcode: string | null = "";

    @observable
    public purchaserSolicitorContactNumber: string | null = "";

    @observable
    public purchaserSolicitorFaxNumber: string | null = "";

    @observable
    public purchaserSolicitorEmailAddress: string | null = "";

    @observable
    public purchaserSolicitorId: string | null = null;

    @observable
    public sellerSolicitorName: string | null = "";

    @observable
    public sellerSolicitorPersonName: string | null = "";

    @observable
    public sellerSolicitorAddress1: string | null = "";

    @observable
    public sellerSolicitorAddress2: string | null = "";

    @observable
    public sellerSolicitorCity: string | null = "";

    @observable
    public sellerSolicitorPostcode: string | null = "";

    @observable
    public sellerSolicitorContactNumber: string | null = "";

    @observable
    public sellerSolicitorFaxNumber: string | null = "";

    @observable
    public sellerSolicitorEmailAddress: string | null = "";

    @observable
    public sellerSolicitorId: string | null = null;

    @observable
    public isSectionComplete: boolean = false;

    @observable
    public completedDate: string = "";

    @observable
    public completedIdentityUserId: string = "";
    //#endregion roperties

    @action
    public fromDto = (reservationDto: ReservationType1SolicitorDTO) => {
        this.id = reservationDto.id;
        this.reservationId = reservationDto.reservationId;
        this.purchaserSolicitorName = reservationDto.purchaserSolicitorName;
        this.purchaserSolicitorPersonName = reservationDto.purchaserSolicitorPersonName;
        this.purchaserSolicitorAddress1 = reservationDto.purchaserSolicitorAddress1;
        this.purchaserSolicitorAddress2 = reservationDto.purchaserSolicitorAddress2;
        this.purchaserSolicitorCity = reservationDto.purchaserSolicitorCity;
        this.purchaserSolicitorPostcode = reservationDto.purchaserSolicitorPostcode;
        this.purchaserSolicitorContactNumber = reservationDto.purchaserSolicitorContactNumber;
        this.purchaserSolicitorFaxNumber = reservationDto.purchaserSolicitorFaxNumber;
        this.purchaserSolicitorEmailAddress = reservationDto.purchaserSolicitorEmailAddress;
        this.purchaserSolicitorId = reservationDto.purchaserSolicitorId;
        this.sellerSolicitorName = reservationDto.sellerSolicitorName;
        this.sellerSolicitorPersonName = reservationDto.sellerSolicitorPersonName;
        this.sellerSolicitorAddress1 = reservationDto.sellerSolicitorAddress1;
        this.sellerSolicitorAddress2 = reservationDto.sellerSolicitorAddress2;
        this.sellerSolicitorCity = reservationDto.sellerSolicitorCity;
        this.sellerSolicitorPostcode = reservationDto.sellerSolicitorPostcode;
        this.sellerSolicitorContactNumber = reservationDto.sellerSolicitorContactNumber;
        this.sellerSolicitorFaxNumber = reservationDto.sellerSolicitorFaxNumber;
        this.sellerSolicitorEmailAddress = reservationDto.sellerSolicitorEmailAddress;
        this.sellerSolicitorId = reservationDto.sellerSolicitorId;
        this.isSectionComplete = reservationDto.isSectionComplete;
        this.completedDate = reservationDto.completedDate;
        this.completedIdentityUserId = reservationDto.completedIdentityUserId;
    };

    public toDto = (): ReservationType1SolicitorDTO => {
        return {
            id: this.id,
            reservationId: this.reservationId,
            purchaserSolicitorName: this.purchaserSolicitorName,
            purchaserSolicitorPersonName: this.purchaserSolicitorPersonName,
            purchaserSolicitorAddress1: this.purchaserSolicitorAddress1,
            purchaserSolicitorAddress2: this.purchaserSolicitorAddress2,
            purchaserSolicitorCity: this.purchaserSolicitorCity,
            purchaserSolicitorPostcode: this.purchaserSolicitorPostcode,
            purchaserSolicitorContactNumber: this.purchaserSolicitorContactNumber,
            purchaserSolicitorFaxNumber: this.purchaserSolicitorFaxNumber,
            purchaserSolicitorEmailAddress: this.sellerSolicitorEmailAddress,
            purchaserSolicitorId: this.purchaserSolicitorId,
            sellerSolicitorName: this.sellerSolicitorName,
            sellerSolicitorPersonName: this.sellerSolicitorPersonName,
            sellerSolicitorAddress1: this.sellerSolicitorAddress1,
            sellerSolicitorAddress2: this.sellerSolicitorAddress2,
            sellerSolicitorCity: this.sellerSolicitorCity,
            sellerSolicitorPostcode: this.sellerSolicitorPostcode,
            sellerSolicitorContactNumber: this.sellerSolicitorContactNumber,
            sellerSolicitorFaxNumber: this.sellerSolicitorFaxNumber,
            sellerSolicitorEmailAddress: this.sellerSolicitorEmailAddress,
            sellerSolicitorId: this.sellerSolicitorId,
            isSectionComplete: this.isSectionComplete,
            completedDate: this.completedDate,
            completedIdentityUserId: this.completedIdentityUserId,
        };
    };
}

export interface ReservationType1SolicitorDTO {
    id: string | undefined;
    reservationId: string;
    purchaserSolicitorName: string | null;
    purchaserSolicitorPersonName: string | null;
    purchaserSolicitorAddress1: string | null;
    purchaserSolicitorAddress2: string | null;
    purchaserSolicitorCity: string | null;
    purchaserSolicitorPostcode: string | null;
    purchaserSolicitorContactNumber: string | null;
    purchaserSolicitorFaxNumber: string | null;
    purchaserSolicitorEmailAddress: string | null;
    purchaserSolicitorId: string | null;
    sellerSolicitorName: string | null;
    sellerSolicitorPersonName: string | null;
    sellerSolicitorAddress1: string | null;
    sellerSolicitorAddress2: string | null;
    sellerSolicitorCity: string | null;
    sellerSolicitorPostcode: string | null;
    sellerSolicitorContactNumber: string | null;
    sellerSolicitorFaxNumber: string | null;
    sellerSolicitorEmailAddress: string | null;
    sellerSolicitorId: string | null;
    isSectionComplete: boolean;
    completedDate: string;
    completedIdentityUserId: string;
}
